export const constant = {
	selector: {
		handler: 'data-m-overlay-handler',
		move: 'data-m-overlay-move',
		target: 'data-m-overlay',
	},
}
